import { useThemeProps } from "@/modules/theme/useTheme.ts";
import { useLingui } from "@lingui/react/macro";
import type { ReactNode } from "react";

/** Symbol for the value added tax (eg. VAT, GST) */
export function VatText(): ReactNode {
    const { t } = useLingui();
    const { vatText = t`VAT` } = useThemeProps();
    return vatText;
}

export function VatTextPercent() {
    return (
        <>
            <VatText />%
        </>
    );
}

export function VatNumberText() {
    const { t } = useLingui();
    const { vatNumberText = t`VAT number` } = useThemeProps();
    return vatNumberText;
}
